import { init } from "./utils/init";
/*
 * this file is used to initialize application
 */
init();
